'use client'

import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import SecureDownload from './SecureDownload'

interface SecureDownloadBlokProps {
  blok: {
    // No props needed - component handles everything internally
  } & SbBlokData
  isInsideStoryblok?: boolean
}

const SecureDownloadBlok: FC<SecureDownloadBlokProps> = ({ blok, isInsideStoryblok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <SecureDownload allowAssetInput={true} isInsideStoryblok={isInsideStoryblok} />
    </div>
  )
}

export default SecureDownloadBlok
